import { render, staticRenderFns } from "./CarouselArrowButton.vue?vue&type=template&id=2358235a&scoped=true"
import script from "./CarouselArrowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselArrowButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarouselArrowButton.vue?vue&type=style&index=0&id=2358235a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358235a",
  null
  
)

export default component.exports